var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetDemandLimits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6914 12.0335L13.1091 3.48312C12.9407 3.3357 12.709 3.3357 12.5405 3.48312L8.91821 6.7053V4.85202C8.91821 4.62036 8.72867 4.43082 8.49701 4.43082H6.58056C6.3489 4.43082 6.15936 4.62036 6.15936 4.85202V9.19037L2.9793 12.0335C2.68446 12.2862 2.874 12.7706 3.25308 12.7706H5.0853V20.7312C5.0853 20.9629 5.27484 21.1524 5.5065 21.1524H20.1432C20.3748 21.1524 20.5644 20.9629 20.5644 20.7312V12.7706H22.3966C22.7967 12.7706 22.9863 12.2862 22.6914 12.0335ZM16.0575 13.0654L12.2036 18.2251C11.8666 18.6674 11.1506 18.3515 11.2559 17.8039L11.9298 14.4764H10.0133C9.57107 14.4764 9.33941 13.992 9.59213 13.634L13.4672 8.47434C13.8041 8.03208 14.5202 8.34798 14.4149 8.89553L13.7409 12.223H15.6574C16.0786 12.223 16.3313 12.7074 16.0575 13.0654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetDemandLimits);
export default __webpack_public_path__ + "static/media/net-demand-limits.16250d7312924c34e848db458c088cd3.svg";
export { ForwardRef as ReactComponent };